import { useEffect, useState } from 'react';

const MOBILE_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const useIsMobileDevice = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    const isMobile = MOBILE_REGEX.test(navigator.userAgent);
    setIsMobileDevice(isMobile);
  }, []);

  return { isMobileDevice };
};
